export default "__VITE_PUBLIC_ASSET__21100b18__"